import { AppConfiguration } from '@nexelem/api';
import { PropsWithChildren, createContext, useContext } from 'react';
import { ConfigSchema } from './schemas/configSchema';

export type AppConfig = ConfigSchema & Omit<AppConfiguration, 'clientId' | 'env'>;

const ConfigContext = createContext<AppConfig | null>(null);

export const useConfig = () => {
  const config = useContext(ConfigContext);
  if (!config) {
    throw new Error('ConfigContext not found');
  }
  return config;
};

type ConfigProviderProps = {
  config: AppConfig;
};

export const ConfigProvider = ({ children, config }: PropsWithChildren<ConfigProviderProps>) => (
  <ConfigContext.Provider value={config}>{children}</ConfigContext.Provider>
);
